<template>
  <!-- 时间选择器，只能选择一个时间，选择时间段使用dateRange,这个选择器只用于表单中 -->
  <div :class="hasSelfSlot? 'yq-date-picker has-slot': 'yq-date-picker'" :style="{'--slot-width': slotWidth}">
    <span v-if="disabled">{{date}}</span>
    <el-date-picker v-else
                    v-model="date"
                    :type="type"
                    range-separator="至"
                    :placeholder="placeholder"
                    @change="changeDate"
                    style="vertical-align: top"
    />
    <span :id="id" class="slot-info">
      <slot name="prefix"></slot>
    </span>
  </div>

</template>

<script>
import {getCurrentInstance, watch} from "vue";

export default {
  emits: ["update:modelValue", "change"],
  props: {
    disabled: {default: false},
    modelValue: {default: ""},
    placeholder: {default: "请选择日期"},
    type: {default: "date"},
    format: {default: "yyyy-MM-dd"}
  },
  name: "",
  components: {
  },
  data() {
    return {
      date: "",
      hasSelfSlot: false,
      slotWidth: "0",
      id: "",
    };
  },
  created() {
    this.id = "Yq_Date_Picker" + (Math.random()*9999).toFixed(0);
    const ins = getCurrentInstance();
    if (ins && ins.slots.prefix) {
      const slotContent = ins.slots.prefix();
      // 有对应的对象
      this.hasSelfSlot = slotContent && slotContent.length > 0;
    }
    this.date = this.modelValue? new Date(this.modelValue).format(this.format): "";
    // watch的三个参数source, hander, option
    watch(() => this.modelValue, () => {
      this.date = this.modelValue? new Date(this.modelValue).format(this.format): "";
    }, {
      // deep: true
    })
  },
  mounted() {
    // 获取当前组件的高度
    // 由于微服务框架本身的问题，获取slot的长度
    this.$nextTick().then(() => setTimeout(() => this.resetSlotWidth(), 10));
  },
  methods: {
    resetSlotWidth() {
      let width = document.querySelector(`#${this.id}`).clientWidth;
      this.slotWidth = width + "px";
    },
    changeDate() {
      if (this.date) {
        this.$emit("update:modelValue", this.date.format(this.format));
        this.$emit("change", this.date.format(this.format));
      } else {
        this.$emit("update:modelValue", "");
        this.$emit("change", "");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.yq-date-picker{
  display: inline-flex;
  position: relative;
  vertical-align: top;
  :deep(.el-date-editor) {
    width: 100%;
    .el-input__wrapper{
      background: transparent;
    }
  }
}
.has-slot{
  :deep(.el-date-editor) {
    .el-input__prefix{
      width: var(--slot-width);
      color: red;
      .el-input__prefix-inner{
        display: none;
      }
    }
  }
  .slot-info{
    white-space: nowrap;
    position: absolute;
    top: 0;
    left: 10px;
    color: #666;
    line-height: 34px;
  }
  .slot-info:after{
    content: ":";
  }
}
</style>